












































import Vue from 'vue';
import Component from 'vue-class-component';
import { cloneDeep } from '@/common/helpers';
import { statusApplication } from '@/common/constants';

const defaultFormData = {
  orderStatusId: statusApplication.SERVICE_PROVIDE.id,
  message: '',
};

@Component<ApproveForm>({
  name: 'IApproveForm',
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  watch: {
    show(n) {
      if (n) {
        this.open();
      } else {
        this.close();
      }
    },
  },
})
export default class ApproveForm extends Vue {
  formData = { ...defaultFormData };

  visible: boolean = false;

  $refs!: {
    formData: any;
  };

  title: string = 'Прием заявления';

  save(): void {
    this.$refs.formData.validate().then((isValid) => {
      if (isValid) {
        this.$emit('saved', { ...this.formData });
      }
    });
  }

  open(): void {
    this.visible = true;
    this.clearForm();
  }

  close(): void {
    this.visible = false;
    this.$emit('update:show', this.visible);
  }

  clearForm() {
    this.formData = cloneDeep(defaultFormData);
  }
}
